import React from 'react'
import { Card, Col, Form, Image, Row, Spinner } from 'react-bootstrap'

// img
import yappy from 'src/assets/yappy.png'
// import TotalPagarCommon from 'src/common/TotalPagarCommon'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import {
  handleInputChangeYappy,
  submitProcesarPago
} from 'src/reducer/action/pago'
import { getTotalPagar } from 'src/helpers/pagoFedpa'
import { withMask } from 'use-mask-input'
import { useMediaQuery } from 'react-responsive'
import { AlertCommon } from 'src/common/AlertCommon'

export const Yappy = ({
  step,
  stepForward
}) => {
  const dispatch = useDispatch()
  const { polizas: polizasPagar } = useSelector(state => state.pago.pagar)
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const {
    register,
    formState: { errors },
    watch
  } = useForm()

  const {
    loadingResponse,
    yappy: { celular },
    formaPago,
    email
  } = useSelector(state => state.pago)

  const handleInputChange = e => {
    e.preventDefault()
    const { name, value } = e.target
    dispatch(handleInputChangeYappy({ name, value }))
  }

  // ** no utilizar handleSubmit de useForm() tiene bug
  const submitDatosToYappyURL = e => {
    e.preventDefault()

    // ! VALIDACIONES DE LOS DATOS ****

    const successUrl = window.location.href
    const failUrl = window.location.href
    dispatch(
      submitProcesarPago({
        idorigen: formaPago,
        email: email,
        pagos: polizasPagar,
        yappy: {
          total: getTotalPagar(polizasPagar),
          telefono: celular,
          successUrl: successUrl,
          failUrl: failUrl
        }
      }, { step, stepForward })
    )
  }

  const getValidarCelular = cel => {
    //   sin valor
    if (cel === '') {
      return false
    }

    let arr = cel?.split('_');

    //   contiene todos los valores numericos
    if (arr.length === 1) {
      return true
    }

    return false
  }

  return (
    <div>
      <br />
      <br />
      <Row className='justify-content-center'>
        <Col md={4}>
          <Card className='shadow border-0'>
            <Card.Body>
              <AlertCommon />
              <div className='text-center'>
                <Image src={yappy} alt='yappy' width={170} fluid />
              </div>
              <div>
                <span className='font-weight-bold'>Indicaciones:</span>
                <p className='form-text'> 
                  Tenga a mano su teléfono para la confirmación del pago
                </p>
              </div>
              <Form onSubmit={submitDatosToYappyURL}>
                <Form.Group className='mb-3 row'>
                  <Col>
                    {/* {watch('celular')} */}
                    <Form.Label className='text-left h6 font-weight-bold'>
                      Número de yappy
                    </Form.Label>
                    <Form.Control
                      type='text'
                      name='celular'
                      className={`border border-2 ${errors?.celular ? 'border-bottom-danger' : ' '
                        }`}
                      {...register('celular', {
                        required: true,
                        minLength: 8,
                        maxLength: 8
                      })}
                      value={celular}
                      onChange={handleInputChange}
                      ref={withMask('9999-9999')}
                    />
                    {/* <span className='form-text text-left'>
                                            Número de yappy
                                        </span> */}
                  </Col>
                </Form.Group>
                <br />
                <div className='text-center'>
                  <button
                    type='submit'
                    variant='primary'
                    className='btn-pay'
                    onClick={submitDatosToYappyURL}
                    disabled={loadingResponse || !getValidarCelular(celular)}
                  >
                    {loadingResponse ? (
                      <Spinner animation='grow' variant='light' size='sm' />
                    ) : (
                      'Pagar'
                    )}
                    &nbsp;
                    {/* // <Icofont icon='pay' /> */}
                  </button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <div style={{ paddingBottom: isMobile ? '100px' : '0' }} />
    </div>
  )
}
